import { render, staticRenderFns } from "./unstartedProduct.vue?vue&type=template&id=4c726f06&scoped=true"
import script from "./unstartedProduct.vue?vue&type=script&lang=js"
export * from "./unstartedProduct.vue?vue&type=script&lang=js"
import style0 from "./unstartedProduct.vue?vue&type=style&index=0&id=4c726f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c726f06",
  null
  
)

export default component.exports